import React, { useState, useEffect, useContext } from "react"
import { FaLock } from "@react-icons/all-files/fa/FaLock"
import * as lookup from "../../../../static/lookup.json"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { PageContext } from "../../context/pageContext"
import { ErrorContext } from "../../context/errorContext"
import { JourneyContext } from "../../context/journeyContext"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  saveApplication,
  fetchApplicationDetails,
  sendEmailBI,
  getTOFpaymentReceipt,
  saveTransactionDetails,
  updateUserTrackerDetails,
  getConfigurationsByType
} from "../../../services/apiservice"
import {
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  transformReceiptToTransaction,
} from "../../services/helperFunctions"
import {
  errorToastr,
  successToastr,
} from "../../../services/error-handler"
import { wordCapital, lineCapital, applyComma, calculateAge } from '../../../shared/functions'
import ContactConsentModal from "../../common/ContactConsentModal"
import useBiContactConsentGate from "../../common/useBiContactConsentGate"
import {
  CONTACT_CONSENT_CONFIG,
  getContactConsentFromJourneyData,
  hasFieldValue,
} from "../../services/contactConsentPolicy"
export default function BIPromise4WealthPlan(props){
  let [isactive, setIsActive] = useState(true)
    const [sectionState, setSectionState] = useContext(SectionContext)
    const [pageState, setPageState] = useContext(PageContext)
    const [errorState, setErrorState] = useContext(ErrorContext);
    const [journeyState, setJourneyState] = useContext(JourneyContext)
    const [conditionState, setConditionState] = useContext(ConditionContext)
  
    const [allJourneyData, setAllJourneyData] = useState()
    const [biApiData, setBiApiData] = useState()
    const [fundValue, setFundValue] = useState()
    const [payNowOrLater, setPayNowOrLater] = useState("later")
    const [pdfData, setPdfData] = useState("")
    const [agreeToDeclaration, setAgreeToDeclaration] = useState(false)
    const [proceedWithOption, setProceedWithOption] = useState()
    const [location, setLocation] = useState()
    const [isChecked, setIsChecked] = useState(true)
    const [skipPayment, setSkipPayment] = useState(false);
    const [isPayBasba, setIsPayBasba] = useState(false)
    const [gstRate, setGstRate] = useState(null);
    const canSendBiEmail = hasFieldValue(
      getContactConsentFromJourneyData(journeyState?.journeyData).email
    )
    const disabledEmailButtonStyle = canSendBiEmail
      ? {}
      : {
          cursor: "not-allowed",
          backgroundColor: "#f4f4f4",
          border: "1px solid #d6d6d6",
          opacity: 0.7,
        }
    const emailAnchorStyle = {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      color: canSendBiEmail ? undefined : "#7a7a7a",
    }

    const contactConsentGate = useBiContactConsentGate({
        journeyState,
        setJourneyState,
        setConditionState,
        saveApplication,
        config: CONTACT_CONSENT_CONFIG,
        buildSavePayload: updatedJourneyData => ({
            applicationData: updatedJourneyData,
            journeyData: {
                _id: journeyState.journeyId,
                lastPage: props.currentPageIndex,
                lastSection: props.currentSectionIndex,
                applicationNo: journeyState.applicationNo,
                illustrationNumber: journeyState.illustrationNumber,
                proposalEntryId: journeyState.proposalEntryId,
                lastPageCode: props.pageId,
                lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
                planOption: journeyState.planOption,
                journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
                channel: journeyState.channel,
            },
        }),
    })

    async function downloadLinkOfPdf(Base64Pdf) {
      // if(!location){
      //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
      //     Base64Pdf: Base64Pdf,
      //   })
      //   setLocation(result.data.location)
      //   window.open(result.data.location,"_self");
      // }else{
      //   window.open(location,"_self");
      // }
      const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        var byteCharacters = atob(Base64Pdf)
        var byteNumbers = new Array(byteCharacters.length)
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        var blob = new Blob([byteArray], { type: "application/pdf" })
        window.navigator.msSaveOrOpenBlob(blob, fileName)
        return
      }
      // For Other Browsers
      const linkSource = "data:application/pdf;base64," + Base64Pdf
      const link = document.createElement("a")
      link.href = linkSource
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      link.remove()
  
      window.addEventListener(
        "focus",
        function () {
          URL.revokeObjectURL(link.href)
        },
        { once: true }
      )
    }
  
    const handleOnChange = () => {
      setIsChecked(!isChecked);
    };
  
    const downloadPdf = async () => {
      let sendEmailPdfData = pdfData
      if (!sendEmailPdfData) {
        if (!biApiData) {
          return
        } else {
          let pdfResult = await pdfDownload({
            applicationNumber: journeyState.applicationNo,
            TID: biApiData?.TransactionId || "",
          })
          setPdfData(pdfResult.data.Base64Pdf)
          sendEmailPdfData = pdfResult.data.Base64Pdf
        }
      }
      downloadLinkOfPdf(sendEmailPdfData)
    }
  
    const printPdf = async () => {
      if (pdfData) {
        printPdf1(pdfData)
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData?.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        printPdf1(pdfResult?.data?.Base64Pdf)
      }
  
      function printPdf1(base64Data) {
        const contentType = "application/pdf";
        const blob = b64toBlob(base64Data, contentType);
        const blobUrl = URL.createObjectURL(blob);
      
        // Open PDF in a new tab
        const newTab = window.open(blobUrl, "_blank");
      
        // Optional: attempt to trigger print (may be blocked by some browsers)
        if (newTab) {
          newTab.onload = () => {
            newTab.print();
          };
        } else {
          alert("Popup blocked. Please allow popups for this site to view and print the PDF.");
        }
      }
      
      function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || ""
        sliceSize = sliceSize || 512
  
        var byteCharacters = atob(b64Data)
        var byteArrays = []
  
        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize)
  
          var byteNumbers = new Array(slice.length)
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
          }
  
          var byteArray = new Uint8Array(byteNumbers)
  
          byteArrays.push(byteArray)
        }
  
        var blob = new Blob(byteArrays, { type: contentType })
        return blob
      }
    }
  const sendEmailInBackground = (triggerDataLayer = false) => {
    if (!biApiData) {
      return
    }
    const payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      applicationNumber: journeyState.applicationNo,
      TID: biApiData?.TransactionId || "",
    }
    const maxAttempts = 3
    const retryDelayMs = 3000

    const attemptSend = async (attempt) => {
      try {
        const res = await sendEmailBI(payload)
        console.log(res, "emailRes")
        if (res?.status) {
          successToastr(res.message)
          if (triggerDataLayer) {
            let formControlKey = "email"
            let journeyFormatData = props.applicationDataInJourneyFormat()
          }
          return
        }
        console.error(`sendEmailBI attempt ${attempt} failed:`, res?.message)
        if (attempt >= maxAttempts) {
          errorToastr("BI email could not be sent.")
        }
      } catch (err) {
        console.error(`sendEmailBI attempt ${attempt} failed:`, err)
        if (attempt >= maxAttempts) {
          errorToastr("BI email could not be sent.")
        }
      }
      if (attempt < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, retryDelayMs))
        await attemptSend(attempt + 1)
      }
    }

    attemptSend(1)
  }

  
    const sendEmail = async (callS3uploadPdf) => {
      if (!biApiData) {
        return
      }
      let payload = {
        journeyId: journeyState.journeyId,
        module: "BIEMAIL",
        applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
        TID: biApiData?.TransactionId || "",
      }
      sendEmailBI(payload).then(res => {
        console.log(res, "emailRes")
        if (res?.status) {
          successToastr(res.message)
        } else {
          errorToastr(res.message)
        }
      })
    }


    //async function to make API call
    const getData = async () => {
      console.log("journeyState",journeyState.journeyId);
      let applicationDetailsPayload = {
        _id: journeyState.journeyId,
      }
      let applicationResult = await fetchApplicationDetails(
        applicationDetailsPayload
      )
  
      let payload = {
        journeyId: journeyState.journeyId,
        allRowData: true,
      }
      let journeyResult = await fetchAllJourneyData(payload)
      console.log("journeyresult",journeyResult);
      if (journeyResult?.lifeAssuredDetails?.proceedWith) {
        setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
      }
      if(journeyResult?.journeyType?.toLowerCase() === "canarapos"){
        setPayNowOrLater("later")
      }
      generateBI(payload).then(async data => {
        console.log(journeyResult, data, "vjhdvhhs")
        setAllJourneyData(journeyResult)
        if(journeyResult?.productDetails?.nVestFundDetails){
          let fund = journeyResult?.productDetails?.nVestFundDetails
          console.log(fund)
          let finalData = {}
          Object.keys(fund).forEach(path => {
            let fundName
            let allocationPercentage
            fundName = fund[path].fundId
            allocationPercentage = fund[path].fundPercent
            console.log(fundName)
            finalData[fundName] = allocationPercentage
          })
          console.log(finalData.ELEF)
          setFundValue(finalData)
        }
        const biJsonFirstYear = data?.data?.BIJson
              ? JSON.parse(data.data.BIJson)[0]
              : {}
              
        setJourneyState(prev => {
          return {
            ...prev,
            premium: Math.round(JSON.parse(data?.data?.BIJson)?.[0].MODAL_PREM_DISP) || 0,
            journeyData: applicationResult.applicationData,
            annualPremiumEquivalent: journeyResult?.productDetails?.annulizedPremium || biJsonFirstYear?.ANN_PREM_YEARLY || biJsonFirstYear?.ANN_PREM || "",
            proceedWith : lookup.proceedWithMapper[journeyResult?.lifeAssuredDetails?.proceedWith]
          }
        })
        setBiApiData(data.data);
        pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: data.data.TransactionId || "",
        })
        .then(pdfResult => {
          setPdfData(pdfResult.data.Base64Pdf);
        })
        .catch(error => {
          console.error("Error while downloading PDF:", error);
        });

        getTOFpaymentReceipt(journeyState.applicationNo)
        .then(res => {
          const receipts = res.data || [];
          const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
          let sum = 0;
          validReceipts.forEach(receipt => {
            sum += parseInt(receipt.amount);
          });
          if (sum >= (Math.round(JSON.parse(data.data.BIJson)?.[0].MODAL_PREM_DISP))) {
            setSkipPayment(true);
          }
          setJourneyState(prev => ({
            ...prev,
            receipts: validReceipts 
          }));
        })
        .catch(err => console.info(err));
      
      })
      .catch(err => {
        console.log("error in save application of save application and call BI function")
      })
    }
  
    const handleEnterPayoutOption = (event, value) => {
      console.log(event.key);
      if (event.key == 'Enter') {
        handlePayOption({ target: { value: value } })
      }
  
    }
  
    //Use Effects
    useEffect(async () => {
      console.log("getdata callaed");
      await getData();
      console.log("bidattttaaaa",biApiData);
    }, [])


    useEffect(() => {
     if (!journeyState?.journeyIdFromStrapi) return;

     getConfigurationsByType({ type: "gst-config" })
       .then(res => {
         const allRates = res?.data?.[0]?.config?.planWiseGSTRates || {};
         const journeyId = journeyState.journeyIdFromStrapi;

         // pick GST rates for this journey
         const journeyRates = allRates[journeyId] || null;
         setGstRate(journeyRates);
       })
       .catch(err => {
         console.error("Failed to fetch GST config", err);
       });
     }, [journeyState?.journeyIdFromStrapi]);
    
  
    // useEffect(() => {
    //   storePdfData()
    // }, [biApiData])
  
    //Page Functions

    const handlePayOption = ({ target }) => {
      console.log(target.value, "value in BI");
      if (target.value === "now") {
        setPayNowOrLater("now")
        setIsPayBasba(false)
      } else if (target.value === "later") {
        setPayNowOrLater("later")
        setIsPayBasba(false)
      } else if (target.value === "basba") {
        setIsPayBasba(true)
      }
    }
  
    const handlePrevious = () => {
      try {
        const payload = {
          journeyId: journeyState.journeyId, 
          buttonClicked:  "Previous", 
        };
        updateUserTrackerDetails(payload)
          .then((response) => {
            if (response?.status) {
              console.log("UserTracker updated successfully:", response.message);
            } else {
              console.error("Error in updating UserTracker:", response?.message);
            }
          })
          .catch((error) => {
            console.error("Error in updateUserTrackerDetails API call:", error);
          })
      } catch (error) {
        console.error("Error in handlePrevious:", error);
      }

      if (proceedWithOption === "manually") {
        props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
        setJourneyState(prev => {
          return {
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      }
    }
  
    // code of tab enter
    const handleEnterPrevious = (event) => {
      if (event?.key == 'Enter') {
        handlePrevious();
      }
    }
    // code of tab enter
    const handleEnterDownload = (event) => {
      if (event?.key == 'Enter') {
        downloadPdf();
      }
    }
    // code of tab enter
    const handleEnterPrint = (event) => {
      if (event?.key == 'Enter') {
        printPdf();
      }
    }
    // code of tab enter
    const handleEnterEmail = (event) => {
      if (event?.key == 'Enter' && canSendBiEmail) {
        sendEmail(true);
      }
    }
    // code of tab enter
    const handleEnterRecalculate = (event) => {
      if (event?.key == 'Enter') {
        handleReCalculate();
      }
    }
  
    const handleProceedClick = (ev) => {
        ev.preventDefault()
        if (!isChecked) return
        contactConsentGate.requestProceed(ev, event => {
            if (skipPayment) {
                handleProceedSkipPayment(event)
            } else {
                handleProceed(event)
            }
        })
    }

    const handleProceed = async ev => {
      ev.preventDefault()
      if (!isChecked) {
        return;
      }
      console.log("tessttttttxxxxxxxxxxx",props);

      // downloadLinkOfPdf(pdfData);
      sendEmailInBackground();
      const ageBI=calculateAge(allJourneyData?.lifeAssuredDetails?.dob)
      // const result = await s3uploadPdfBI({
      //   applicationNumber: journeyState.applicationNo,
      //   Base64Pdf: pdfData,
      // })
      // const b64Data = pdfData
      // const blob = b64toBlob(b64Data, "application/pdf")
      // let formData = new FormData()
      // if (blob) {
      //   const file = blob
      //   formData.append("doc", file)
      //   formData.append("sub", false)
      //   formData.append("docPurpose", "BIPDF")
      //   try {
      //     const res = await uploadDocument(formData, journeyState.applicationNo)
      //     console.log({ res })
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }
      // function b64toBlob(b64Data, contentType, sliceSize) {
      //   contentType = contentType || ""
      //   sliceSize = sliceSize || 512
  
      //   var byteCharacters = atob(b64Data)
      //   var byteArrays = []
  
      //   for (
      //     var offset = 0;
      //     offset < byteCharacters.length;
      //     offset += sliceSize
      //   ) {
      //     var slice = byteCharacters.slice(offset, offset + sliceSize)
  
      //     var byteNumbers = new Array(slice.length)
      //     for (var i = 0; i < slice.length; i++) {
      //       byteNumbers[i] = slice.charCodeAt(i)
      //     }
  
      //     var byteArray = new Uint8Array(byteNumbers)
  
      //     byteArrays.push(byteArray)
      //   }
  
      //   var blob = new Blob(byteArrays, { type: contentType })
      //   return blob
      // }


        let temp = journeyState.journeySteps
        setJourneyState(prev => {
          return {
            ...prev,
            journeySteps: temp,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            paymentStep: "L",
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      console.log("journeystateee222222222222222e",journeyState);
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
      let sendPayload = {
        applicationData: journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          paymentStep: payNowOrLater === "now" ? "N" : "L",
          isBasbaAttempted: isPayBasba ? "Y" : "N",
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
          planOption: journeyState.planOption,
          canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null,
          ageAtBI:ageBI
          },
          posDashboardListingData:{
            canaraPosCaseType: "sendCaseToCustomer"
          }
        // base64Data: pdfData,
      }
      saveApplication(sendPayload).then(res => {
        console.log(res, "application response")
        props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
      }).catch(err => {
        console.log(err, "err in saveApplication benefit-illustration")
      })
    }

    const handleProceedSkipPayment = (e) => {
      e.preventDefault();
      const temp = journeyState.journeySteps;
      let makePaymentPageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
      temp.pages[makePaymentPageIndex].sections = temp.pages[makePaymentPageIndex].sections.filter(section => section.sectionId === "eNach-physicalMandate")//show only e-nach section if skip payment
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp
        }
      });
    
      let sendPayload = {
        applicationData: journeyState.journeyData,
        skipPayment:'Y',
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex + 1,
          lastSection: 0,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          premium: Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP)|| 0,
          lastPageCode: props.pageId,
          paymentStep: "N",
          isBasbaAttempted: isPayBasba ? "Y" : "N",
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          planOption: journeyState.planOption,
          canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
        },
      }
    
      saveApplication(sendPayload).then(async res => {
        console.log(res, "application response");
        props.setCurrentPageIndex(prev => prev + 1);
        setErrorState({});
        props.setCurrentSectionIndex(0); // this moves to first section of next page
    
        // Save transaction details if skipPayment is true
        if (skipPayment) {
          const validReceipts = journeyState.receipts || [];
          const transactions = validReceipts.map(receipt => transformReceiptToTransaction(receipt, journeyState));
    
          const transactionPayload = {
            journeyId: journeyState.journeyId,
            applicationNumber: journeyState.applicationNo,
            status: 'Success',
            skipPayment: 'Y',
            transactions: transactions
          };
    
          //console.log(transactionPayload, "transactionPayload");
          let saveResp = await saveTransactionDetails(transactionPayload);
          console.log(saveResp, "saveTransactionDetails");
        }
        
  
      }).catch(err => {
        console.log(err, "err in saveApplication benefit-illustration");
      });
    }
  
  
    const handleReCalculate = () => {
        props.setCurrentPageIndex(0)
        props.setCurrentSectionIndex(0)
        const tempPage = journeyState.journeyData[0]
        // user activity
        try {
          const payload = {
          ourneyId: journeyState?.journeyId, 
            buttonClicked: "ReCalculate", 
          };
          updateUserTrackerDetails(payload)
            .then((response) => {
              if (response?.status) {
                console.log("UserTracker updated successfully:", response.message);
              } else {
                console.error("Error in updating UserTracker:", response?.message);
              }
            })
            .catch((error) => {
              console.error("Error in updateUserTrackerDetails API call:", error);
            })
        } catch (error) {
          console.error("Error in handleReCalculate:", error);
        }
        setPageState(prev => {
          return {
            ...prev,
            pageId: tempPage.pageId,
            pageData: tempPage.pageData,
          }
        })
        const tempState = journeyState.journeyData[0].pageData[0]
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: tempState.sectionId,
            sectionData: tempState.sectionData,
          }
        })
    }  

    const handleSendLinkToSales = (ev) => {
      ev.preventDefault()
      if (!isChecked) {
        return;
      }
      sendEmail(true);
      console.log("tesstttttt",journeyState.journeySteps.pages);
      let temp = journeyState.journeySteps

      temp.pages = temp.pages.filter(page => page.pageId !== "PageFlexiEdgeFillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "PageFlexiEdgeUploadDocuments")
      temp.pages.push(...lookup.sendLinktosales)
      if(allJourneyData?.productDetails?.premiumFrequency === "SG"){
        temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
      }
      console.log(temp.pages)

      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "L",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
          canaraPosCaseType: "sendLinktosales"
        }
      })
    console.log("journeystateeee",journeyState);
    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      }
    })
    // let optInPayload = {
    //   "mobileNo": allJourneyData.salesAgentDetails.mobileNo
    // }
    // let whatsAppOptres = whatsAppOptin(optInPayload)
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        planOption: journeyState.planOption,
        canaraPosCaseType: "sendLinktosales"
      },
      posDashboardListingData:{
        canaraPosCaseType: "sendLinktosales"
      }
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      successToastr('Application will be visible on sales Dashboard')
      props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration")
    })
    }


    let personalDetails = [
      {
          q1: "Name of the Prospect/ Policyholder:",
          ans1:  (allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) : (wordCapital(allJourneyData?.lifeAssuredDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.lastName))) || "",
          q2: "Age & Gender:",
          ans2:  `${(allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"? (getAge(allJourneyData?.proposerDetails?.dob)) :(getAge(allJourneyData?.lifeAssuredDetails?.dob)))} | ${ (allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"? lineCapital(getValueFromLookup("gender",allJourneyData?.proposerDetails?.gender)) :lineCapital(getValueFromLookup("gender",allJourneyData?.lifeAssuredDetails?.gender)))}`
      },
      {
          q1: "Name of the Life Assured:",
          ans1: `${wordCapital(allJourneyData?.lifeAssuredDetails?.firstName ?? '')+ " " + wordCapital(allJourneyData?.lifeAssuredDetails?.middleName ?? '')+ " " + wordCapital(allJourneyData?.lifeAssuredDetails?.lastName)}`,
          q2: "Age & Gender:",
          ans2:`${(getAge(allJourneyData?.lifeAssuredDetails?.dob))} | ${lineCapital(getValueFromLookup("gender",allJourneyData?.lifeAssuredDetails?.gender))}`
      },
      {
          q1: "Sum Assured:",
          ans1: allJourneyData?.productDetails?.sumAssured,
          q2: "Plan Option",
          ans2: allJourneyData?.productDetails?.planOption === "ULPWP1" ? "Promise4Wealth Maximiser" : allJourneyData?.productDetails?.planOption === "ULPWP2" ? "Promise4Wealth LongLife" : allJourneyData?.productDetails?.planOption === "ULPWP3" ? "Promise4Wealth Shield" : "" 
      },
      {
          q1: "Policy Term & Premium Payment Term:",
          ans1: `${allJourneyData?.productDetails?.policyTerm || "NA"} / ${allJourneyData?.productDetails?.premiumPaymentTerm === "A99" ? (100 -getAge(allJourneyData?.lifeAssuredDetails?.dob))  : allJourneyData?.productDetails?.premiumPaymentTerm || "NA"}`,
          q2: "Mode of payment of premium:",
          ans2:`${lineCapital(getValueFromLookup(
            "premiumFrequency",
            allJourneyData?.productDetails?.premiumFrequency
          ) ?? '') || "NA"}`,
      },
      {
          q1: "Amount of Installment Premium",
          ans1: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP : ""}`,
          q2: "Staff/ Non Staff",
          ans2: `${(allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff === "Y" ? "Yes" : "No") || "NA"}`
      },
      {
        q1: "Employer/Organisation",
        ans1: getValueFromLookup("companyList", allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerName) || "NA",
    }
  ]
  return (
    <>
      <style>
        {`
        .table-design .table-bg{
          border:none;
        }

        .option-buit-design-new-new-design::after{
          height: 2rem
        }
        .shadow-box-card{
          background-color: #fff;
          box-shadow: 0px 0px 10px #ccc;
          border-radius: 10px;
          padding: 0px 0px;
          float: left;
          width: 100%;
          margin-bottom: 30px;
          height: 172px;
        }
        .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
          background-color: #ededed;
          left: 0px;
          top: 0px;
        }
        radio-line{
          width: 100%;
          height: 100%
        }
        .customradio{
          padding: 22px 0px
        }
        .customradio .checkmark {
          top: 22px !important;
        }
        .by-pay{
          bottom: 8px
        }
        resent-bi-center{
          position: relative;
        }
        .eky-resend {
          margin: auto;
          right: 25px;
          position: relative;
          left: 4px
        }
        .custom-otp{
          margin: auto
        }
      
      `}

      </style>
      {allJourneyData && biApiData && (<div className='container'>
        <form id="declaration-form" name="declaration-form" action method="post" autoComplete="off" noValidate="novalidate">
          <div className="iselect-padding mt-20">
            <div className="iselect-box-design mb">
              <div className="heading-design">
                <div className="iselect-padding left-side-head">
                  <h1 className="iselect-heading">Benefit Illustration</h1>
                  <span className="subhead">Canara HSBC Life Insurance Promise4Wealth Plan &nbsp; |  &nbsp; UIN: 136L096V01 </span> </div>
                <div className="app-quatation mt hidden-desktop-screen">
                  <div className="application-design-number">Application Number: {journeyState.applicationNo}</div>
                </div>
              </div>
              <div className="bi-summary">
                <div className="auther-description mt-20">
                    <h3>
                    Dear{" "}
                    {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                       { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.proposerDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.proposerDetails?.title === "MRS" ?  'Mrs. ' : ""
                          : (allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. ': ``)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.gender.toUpperCase() == "M" || allJourneyData?.proposerDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                          : (allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "M" || allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }
                    </h3>
                  <p className="benefit-title">Thank you for showing interest in our Canara HSBC Life Insurance Promise4Wealth Plan. Based on the details provided by you, and reproduced below, the illustration customised to your requirements is appended.
                  <br/>
                  <br/>
                  Please note that this illustration is indicative and the actual values may vary depending on performance of the participating fund managed by the Company.
                  </p>
                </div>
              </div>
              <div className="Bi-design-structure-table mt-50 iselect-mg-bottom">
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table">Personal Details of Life to be Assured</h2>
                    <div className="table-bg">
                      <table className="table">
                        <tbody>
                            {personalDetails.map((elem, index)=>{
                              return(
                              <tr className={`table-color${index%2==0?"-grey":""}`}>
                                  <td width="33%">{elem.q1}</td>
                                  <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>{elem.ans1}</td>
                                  <td width="26%" align="left">{elem.q2}</td>
                                  <td width="24%" align="right">{elem.ans2}</td>
                              </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="col-md-12">
                <div className="table-responsive table-design">
                  <div className="table-bg">
                    <table className="table">
                    <tbody>
                    <tr className="headline-table brd-flexi-product" style={{color: '#fff !important'}}>
                      <td colSpan={4} align="center">Plan Details</td>
                    </tr>
                    <tr className={`table-color${2%2==0?"-grey":""}`}>
                      <td width="33%">Name of the Product:</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>{(getValueFromLookup(
                            "planOption",
                            allJourneyData?.productDetails?.planOption
                          ) ?? '') || "NA"}</td>
                      <td width="26%" align="left"> Tagline</td>
                      <td width="24%" align="right"> An Individual Linked Life Insurance cum Savings Plan</td>
                    </tr>
                    <tr className={'table-color'} >
                      <td  width="33%" align="left"> Unique Identification No:</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>136L096V01</td>
                      <td width="26%" align="left"> GST Rate:</td>
                      <td width="24%" align="right"> {gstRate?.gstRateYear1 || "0"}%</td>
                    </tr>
                    <tr className={'table-color-grey'}>
                      <td  width="33%" align="left"> Systematic Withdrawal % (of fund value) per Annum</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>
                      {allJourneyData?.productDetails?.withdrwalOption === "Y" ? lineCapital(getValueFromLookup(
                            "SwoFundValueWithdrawnAlphaWealth",
                            allJourneyData?.productDetails?.fundValueWithdrwalYear
                          ) ?? '') || "NA" : "NA"}
                      </td>
                      <td width="26%" align="left"> Systematic Withdrawal Payout Frequency</td>
                      <td width="24%" align="right">
                      {allJourneyData?.productDetails?.withdrwalOption === "Y" ? lineCapital(getValueFromLookup(
                            "SwoFrequency",
                            allJourneyData?.productDetails?.chooseFreqSwo
                          ) ?? '') || "NA" : "NA"}
                      </td>
                    </tr>
                    <tr className={'table-color'}>
                      <td  width="33%" align="left">Systematic Withdrawal Option</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>
                      {lineCapital(getValueFromLookup(
                            "yesNo",
                            allJourneyData?.productDetails?.withdrwalOption
                          ) ?? '') || "NA"}
                      </td>
                      
                         <td width="26%" align="left"> </td>
                      <td width="24%" align="right">
                     
                      </td>
                    </tr>
                    </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="col-md-12">
                <div className="table-responsive table-design">
                  <div className="table-bg">
                    <table className="table">
                      <tbody>
                        <tr className="headline-table brd-flexi-product" style={{color: '#fff !important' , borderBottom:"1px solid"}}>
                          <td colSpan={4} align="center">Fund Allocation</td>
                        </tr>
                        <tr className={'table-color-grey'} style={{"background-color":" var(--lumiq-card-bg)", "color": "#fff"}}>
                          <th width="33%" align="center">Fund</th>
                          <th width="27%" align="center" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}>SFIN No</div> </th>
                          <th width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>Allocation</div> </th>
                          <th width="14%" align="right"><div style={{"float":"right"}}> Risk</div></th>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left"> Large Cap Advantage Fund:</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF02109/06/20LARCPADFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.LCAF: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left">Multicap Momentum Quality Index fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF02410/03/25MLMMQEQFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.MMQIF: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left"> Emerging Leaders Equity Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF02020/12/17EMLEDEQFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.ELEF: `0`}%</div> </td>
                          <td width="24%" align="left"> <div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left">India Multi-Cap Equity Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF01816/08/16IMCAPEQFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.IMEF: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left">Equity II Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF00607/01/10EQUTYIIFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.PEF2: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left">Growth Plus Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF00913/09/10GROWTPLFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.GWF3: `0`}%</div> </td>
                          <td width="24%" align="right"><div style={{"float":"right"}}> Medium to High</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left">Balanced Plus Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF01013/09/10BLNCDPLFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.BLF3: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> Medium</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left">Debt Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF00409/07/08INDEBTFUND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.BDF1: `0`}%</div> </td>
                          <td width="24%" align="right"><div style={{"float":"right"}}>Low to Medium</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left">Liquid Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF00514/07/08LIQUIDFUND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.CSF1: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> Low</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left">India Manufacturing fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF02305/11/24INMFGEQFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.IMAAF: `0`}%</div> </td>
                          <td width="24%" align="right"><div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left">Midcap Momentum Growth Index fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF02218/03/24 MIDMIEQFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.MMGIF: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left">Nifty Alpha 50 Index fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF02502/04/25NFALFEQFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.NAFIF: `0`}%</div> </td>
                          <td width="24%" align="right"><div style={{ "float": "right" }}> High</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td width="33%" align="left">Nifty 500 Multifactor 50 Index Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{ "display": "flex", "justifyContent": "space-around" }}> ULIF02715/09/25MLFACEQFND136</div></td>
                          <td width="26%" ><div style={{ "display": "flex", "justifyContent": "space-around" }}>{fundValue ? fundValue.NMFIF : `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{ "float": "right" }}> High</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td width="33%" align="left">NextGen Consumption Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{ "display": "flex", "justifyContent": "space-around" }}>  ULIF02910/11/25NGCONEQFND136</div></td>
                          <td width="26%" ><div style={{ "display": "flex", "justifyContent": "space-around" }}>{fundValue ? fundValue.NGCMF : `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{ "float": "right" }}> High</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td width="33%" align="left">BSE 500 Enhanced Value 50 Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{ "display": "flex", "justifyContent": "space-around" }}> ULIF03026/03/26ENVALEQFND1366</div></td>
                          <td width="26%" ><div style={{ "display": "flex", "justifyContent": "space-around" }}>{fundValue ? fundValue.BFEVF : `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{ "float": "right" }}> High</div></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="clearfix" />

              <div className="transactionDetailsWrap">
                <div className="detailContentWrap">
                  <div className="row">
                    <div className="buttonWrap">
                      <div 
                        className="button submit-btn"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterDownload(e)}
                        onClick={downloadPdf}
                        >
                          <a> Download</a></div>
                      <div 
                        className="button submit-btn"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterPrint(e)}
                        onClick={printPdf}
                      >
                        <a> Print</a></div>
                      <div 
                        className={
                          canSendBiEmail ? "button submit-btn" : "button manually-submit-btn"
                        }
                        style={{
                          cursor: canSendBiEmail ? "pointer" : "not-allowed",
                          ...disabledEmailButtonStyle,
                        }}
                        tabIndex={canSendBiEmail ? "0" : "-1"}
                        aria-disabled={!canSendBiEmail}
                        title={canSendBiEmail ? "Send BI on email" : "Enter email to enable this button"}
                        onKeyPress={(e) => handleEnterEmail(e)}
                        onClick={() => {
                          if (canSendBiEmail) {
                            sendEmail(true)
                          }
                        }}
                      >
                        <a style={emailAnchorStyle}>
                          {!canSendBiEmail && <FaLock size={12} />}
                          Email
                        </a>
                      </div>
                      <div 
                      className="button submit-btn"
                       style={{
                        cursor:
                          proceedWithOption === "manually"
                            ? "pointer"
                            : "default",
                      }}
                      tabIndex="0"
                      disabled={
                        proceedWithOption === "manually" ? false : true
                      }
                      onKeyPress={(e) => handleEnterRecalculate(e)}
                      onClick={handleReCalculate}
                      >
                        <a>Re-Calculate</a></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="clearfix" />

              {/* <div className="row iAgree ls3 text-center mt-20">
                <div className="form-group">
                  <div className="inner-addon left-addon">
                    <div className="checkbox1">
                      <input name="checkboxG6" id="checkboxG6" className="css-checkbox" type="checkbox" checked={isChecked} onChange={handleOnChange} />
                      <label htmlFor="checkboxG6" className="css-label"> I agree to the Disclosures and Disclaimers as mentioned below </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" /> */}
              {/* <div className="iselect-mg-bottom  mt-20 mb-30">
                <div className="col-md-12">
                  <p className="p-text text-center">OTP has been sent to your registered mobile number xxxxxxxxxx and email address test@gmail.com. It will be valid for 30 min.</p>
                  <div className="clearfix" />
                  <div className="col-md-5 col-xs-12 pl pr-30 resent-bi-center mt-30 custom-otp">
                    <label className="title-bg text-left" style={{marginLeft: '5px'}}>Enter OTP</label>
                    <input type="text" className="form-control" name="otp" placeholder="xxxx" />
                    <div className="resend-otp eky-resend"><a href="#">Resend OTP <span className="fa fa-angle-right" /></a></div>
                  </div>
                </div>
              </div>
              <div className="clearfix" /> */}
              <div className="option-buit-design-new-structure Bi-page-pay-structure mt-30">
                <div className="col-md-12">
                  <div className="option-buit-design-new-structure-box">
                    {skipPayment && <p style={{
                    textAlign : "center",
                    fontSize : "18px",
                    marginTop : "30px"

                  }}>Premium of Rs {`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP)) : "NA"}`} is adjusted against transfer of funds from old application</p>}  
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                <div className="col-md-12">
                  <div className="but-center text-center">
                  {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    }
                    <input onClick={handleProceedClick} className="previous-btn cen text-uppercase ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="button" value="PROCEED"  />
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                    <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                    {/* <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} /> */}
                      </span>
                    }
              
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design">
              <h2>Notes:</h2>
              <ul>
                <li>This illustration has been produced by Canara HSBC Life Insurance to help you understand the benefits of your product, Canara HSBC Life Insurance Promise4Wealth.This must be read in conjunction with the
product brochure, which describes all Features, Charges,Terms, Conditions & Exclusions.
</li>
                <li>Fund management charge is based on the specific fund option(s) chosen</li>
                <li>In case rider is opted, rider premium shall be collected explicitly and not by way of cancellation of units.</li>
                <li>The amount payable under the Return of Mortality Charge (RoMC) feature shall exclude any additional charges in respect of mortality that are deducted due to the Life Assured being sub-standard life on grounds of
health or is a higher risk for factors other than health such as occupation, etc. RoMC does not include Premium Funding Benefit Charge. RoMC is applicable only for Promise4Wealth Maximiser option and Promise4Wealth Long Life option only.
</li>
                <li>The benefit illustration is subject to payment of stipulated premiums on due dates.The premium shall be adjusted on the due date even if it has been received in advance.</li>
                <li> Systematic Withdrawal Option (SWO) is a systematic partial withdrawal facility. Under this option, a pre-decided percentage of the fund value will be withdrawn and paid to the Policyholder at a chosen
frequency for the remainder of the Policy starting from the chosen Policy year.The Policy holder can choose SWO at inception or anytime during the PolicyTerm.Policyholder canopt out of this option at any time
even after the withdrawals have started.For more details regarding SWO,please refer to the product brochure or sample policy contract on the Company's website.</li>
                <li>At anytime, the Death Benefit will not be less than 105% of all Premiums paid by you up to the date of death.
</li>
                </ul>
                <h2>Disclaimers</h2>
                <ul>
                  <li>Some benefits are guaranteed and some benefits are variable with returns based on the future performance of your Insurer carrying on life insurance business. If your policy offers guaranteed returns then these will
be clearly marked “guaranteed” in the illustration table. If your policy offers variable returns then the illustrations will show two different rates of assumed future investment returns.These assumed rates of return
are not guaranteed and they are not the upper or lower limits of what you might get back, as the value of your policy is dependent on a number of factors including future investment performance.</li>
                  <li>Canara HSBC Life Insurance Company Limited is the name of the insurance company and Canara HSBC Life Insurance Promise4Wealth is only the name of the unit linked life insurance contract and does not in
any way indicate the quality of the contract, its future prospects or returns.</li>
                  <li>The various funds offered under this contract are the names of the funds and do not in any way indicate the quality of these plans, their future prospects and returns.</li>
                  <li>Unit Linked insurance products are different from the traditional insurance products and are subject to the risk factors.
</li>
                  <li>The premium paid in unit linked insurance policies are subject to investment risks associated with capital market and the NAVs of the units may go up or down based on the performance of fund and factors
influencing the capital market and the insured is responsible for his/her decisions.
</li>
                  <li>Past performance of the investment funds donot indicate the future performance of the same. Investors in the Scheme are not being offered any guaranteed/ assured returns.</li>
                  <li>You maybe entitled for tax benefits under Section 80C and Section 10(10D), as per the Income Tax Act,1961, as amended from time to time. For tax related queries, please contact your independent tax advisor.</li>
                  <li>I have understood the inbuilt features of the policy and the applicable charges. I am fully aware of investment risks under this policy.
I ALSO UNDERSTAND THAT WHILST 100% OF MY FIRST YEAR PREMIUM WILL BE INVESTED IN CHOOSEN INVESTMENT FUNDS.THERE ARE CHARGES DURING THE FIRST POLICY YEAR
AS GIVEN IN THE BENEFIT ILLUSTRATION.
</li>
               </ul>
            </div>
          </div>
        </div>
         {/* <!--mobile view button--> */}
          <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1 canara-pos-bi-btn">
            <div className="iselect-mg-bottom">
              <div className="col-md-12">
                <div className="but-center text-center">
                {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div
                        className="submit-btn cen"
                        style={{ marginRight: "5px" }}
                        aria-hidden="true"
                        >
                        {" "}
                        <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                        </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div
                          className="submit-btn cen"
                          style={{ marginRight: "5px" }}
                          aria-hidden="true"
                          >
                          {" "}
                          <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                          </div>
                    }
                  <div className="previous-btn cen">
                    <a>
                      {" "}
                      <button
                        value="button1"
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "#fff",
                        }}
                        onClick={handleProceedClick}
                      >
                        Proceed
                      </button>{" "}
                    </a>
                  </div>
                  <div className="previous-btn cen send-link-to-cust">
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                        <input className="previous-btn cen text-uppercase ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                      </span>
                    }
                  </div>
                  {/* <div className="previous-btn cen send-link-to-cust">
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                        <input className="previous-btn cen text-uppercase ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} />
                      </span>
                    }
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!--mobile view button-->  */}
          <div className="clearfix"></div>
          
      </div>)}
      <ContactConsentModal
        show={contactConsentGate.showModal}
        initialValues={contactConsentGate.initialValues}
        onClose={contactConsentGate.handleModalClose}
        onProceed={contactConsentGate.handleModalProceed}
        channel={props.channel}
        lookup={journeyState.lookup}
      />
    </>

  )
}